export default __webpack_public_path__ + "static/media/repair.8eb346c5.jpg";